import { $http } from '@/utils';

/**
 * @namespace Service
 * @class Regenerate
 * @exports Service/Regenerate
 * @description API Regenerate Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class Regenerate {
	/**
	 * @static @name post
	 * @description Performs API Regenerate
	 * @returns {Object} Promise a http response
	 */
	static post(payload) {
		return $http.post(`account/registration/regenerate`, payload);
	}
}
